<template>
    <div class="imgbtncard">
        <div class="img">
            <img :src="data.Image || require('@/assets/default-big.png')" />
        </div>
        <div class="title">{{data.Title}}</div>
        <div class="date">{{data.Number}}</div>
        <!-- <div class="date">{{dateformat}}</div> -->
        <div class="btn_box">
            <div class="btn">
                <a v-if="process" class="Orange_btn islogin" :href="`/Conference/ActivityProcess?Id=${data.Id}`">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g fill="#ffffff">
                                <g id="surface1">
                                    <path
                                        d="M86,41.28c-45.86219,0 -81.7,42.4625 -81.7,42.4625c-1.12875,1.29 -1.12875,3.225 0,4.515c0,0 35.83781,42.4625 81.7,42.4625c45.86219,0 81.7,-42.4625 81.7,-42.4625c1.12875,-1.29 1.12875,-3.225 0,-4.515c0,0 -35.83781,-42.4625 -81.7,-42.4625zM86,48.16c9.04344,0 17.68375,1.86781 25.6925,4.73c5.375,6.07375 8.7075,14.01531 8.7075,22.79c0,19.04094 -15.35906,34.4 -34.4,34.4c-19.04094,0 -34.4,-15.35906 -34.4,-34.4c0,-8.77469 3.225,-16.71625 8.6,-22.79c8.03563,-2.87562 16.72969,-4.73 25.8,-4.73zM48.805,57.9425c-2.58,5.375 -4.085,11.395 -4.085,17.7375c0,22.76313 18.51688,41.28 41.28,41.28c22.76313,0 41.28,-18.51687 41.28,-41.28c0,-6.31562 -1.43781,-12.3625 -3.9775,-17.7375c19.43063,9.87656 33.40563,24.20094 36.98,28.0575c-5.59,6.04688 -36.53656,37.84 -74.2825,37.84c-37.74594,0 -68.6925,-31.79312 -74.2825,-37.84c3.57438,-3.87 17.61656,-18.18094 37.0875,-28.0575zM86,58.48c-9.46,0 -17.2,7.74 -17.2,17.2c0,9.46 7.74,17.2 17.2,17.2c9.46,0 17.2,-7.74 17.2,-17.2c0,-9.46 -7.74,-17.2 -17.2,-17.2zM86,65.36c5.73781,0 10.32,4.58219 10.32,10.32c0,5.73781 -4.58219,10.32 -10.32,10.32c-5.73781,0 -10.32,-4.58219 -10.32,-10.32c0,-5.73781 4.58219,-10.32 10.32,-10.32z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>查看詳情</span>
                </a>
                <a v-else class="Orange_btn islogin" :href="`/Conference/Journal?Id=${data.Id}`">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g fill="#ffffff">
                                <g id="surface1">
                                    <path
                                        d="M86,41.28c-45.86219,0 -81.7,42.4625 -81.7,42.4625c-1.12875,1.29 -1.12875,3.225 0,4.515c0,0 35.83781,42.4625 81.7,42.4625c45.86219,0 81.7,-42.4625 81.7,-42.4625c1.12875,-1.29 1.12875,-3.225 0,-4.515c0,0 -35.83781,-42.4625 -81.7,-42.4625zM86,48.16c9.04344,0 17.68375,1.86781 25.6925,4.73c5.375,6.07375 8.7075,14.01531 8.7075,22.79c0,19.04094 -15.35906,34.4 -34.4,34.4c-19.04094,0 -34.4,-15.35906 -34.4,-34.4c0,-8.77469 3.225,-16.71625 8.6,-22.79c8.03563,-2.87562 16.72969,-4.73 25.8,-4.73zM48.805,57.9425c-2.58,5.375 -4.085,11.395 -4.085,17.7375c0,22.76313 18.51688,41.28 41.28,41.28c22.76313,0 41.28,-18.51687 41.28,-41.28c0,-6.31562 -1.43781,-12.3625 -3.9775,-17.7375c19.43063,9.87656 33.40563,24.20094 36.98,28.0575c-5.59,6.04688 -36.53656,37.84 -74.2825,37.84c-37.74594,0 -68.6925,-31.79312 -74.2825,-37.84c3.57438,-3.87 17.61656,-18.18094 37.0875,-28.0575zM86,58.48c-9.46,0 -17.2,7.74 -17.2,17.2c0,9.46 7.74,17.2 17.2,17.2c9.46,0 17.2,-7.74 17.2,-17.2c0,-9.46 -7.74,-17.2 -17.2,-17.2zM86,65.36c5.73781,0 10.32,4.58219 10.32,10.32c0,5.73781 -4.58219,10.32 -10.32,10.32c-5.73781,0 -10.32,-4.58219 -10.32,-10.32c0,-5.73781 4.58219,-10.32 10.32,-10.32z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>查看詳情</span>
                </a>
            </div>
            <div class="btn">
                <a
                    class="Orange_btn"
                    :class="{'islogin':islogin}"
                    href="javascript:;"
                    @click="download(data.Id)"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="18"
                        height="18"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none" />
                            <g id="original-icon" :fill="islogin?'#ffffff':'#cccccc'">
                                <g id="surface1">
                                    <path
                                        d="M86,10.32c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,24.08c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM86,37.84c-1.89469,0 -3.44,1.54531 -3.44,3.44c0,1.89469 1.54531,3.44 3.44,3.44c1.89469,0 3.44,-1.54531 3.44,-3.44c0,-1.89469 -1.54531,-3.44 -3.44,-3.44zM85.6775,51.4925c-0.14781,0.02688 -0.29562,0.06719 -0.43,0.1075c-1.59906,0.36281 -2.72781,1.80063 -2.6875,3.44v74.175l-21.6075,-21.6075c-0.83312,-0.86 -2.05594,-1.22281 -3.225,-0.9675c-1.29,0.22844 -2.32469,1.16906 -2.6875,2.41875c-0.36281,1.26313 0.01344,2.60688 0.9675,3.49375l27.09,26.9825c0.12094,0.18813 0.26875,0.37625 0.43,0.5375c0.06719,0.08063 0.13438,0.14781 0.215,0.215c0.20156,0.16125 0.41656,0.30906 0.645,0.43c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.04031,0 0.06719,0 0.1075,0c0.06719,0.04031 0.14781,0.08063 0.215,0.1075c0.13438,0.04031 0.28219,0.08063 0.43,0.1075c0.36281,0.05375 0.71219,0.05375 1.075,0c0.06719,0 0.14781,0 0.215,0c0.29563,-0.06719 0.59125,-0.17469 0.86,-0.3225c0.45688,-0.22844 0.86,-0.56437 1.1825,-0.9675l27.305,-27.1975c1.37063,-1.37062 1.37063,-3.57437 0,-4.945c-1.37062,-1.37062 -3.57437,-1.37062 -4.945,0l-21.6075,21.6075v-74.175c0.04031,-0.99437 -0.36281,-1.94844 -1.075,-2.62031c-0.72562,-0.68531 -1.70656,-1.02125 -2.6875,-0.92719zM6.88,113.52v41.28c0,5.65719 4.66281,10.32 10.32,10.32h137.6c5.65719,0 10.32,-4.66281 10.32,-10.32v-41.28h-6.88v41.28c0,1.94844 -1.49156,3.44 -3.44,3.44h-137.6c-1.94844,0 -3.44,-1.49156 -3.44,-3.44v-41.28z"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>檔案下載</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import API from "@/service/conference";
import Common from "@/common";
export default {
    name: "imgbtncard",
    components: {},
    props: {
        data: {
            type: Object
        },
        islogin: {
            type: Boolean
        },
        process: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {};
    },
    methods: {
        download(Id) {
            const vm = this;
            if (!vm.islogin) {
                return false;
            }
            if(process) {
                API.getProcessDetail({ Id: Id }).then(res => {
                if (res.Ok) {
                    const url = res.Data.DocumentFile;
                    // location.href = url;
                    Common.download(url, { type: "pdf" });
                }
            });
            }else {
                API.getJournalDetail({ Id: Id }).then(res => {
                if (res.Ok) {
                    const url = res.Data.DocumentFile;
                    // location.href = url;
                    Common.download(url, { type: "pdf" });
                }
            });
            }
            
        }
    },
    computed: {
        // dateformat() {
        //     const vm = this;
        //     const date = `${vm
        //         .$moment(vm.StartOn)
        //         .format("YYYY-MM-DD")} ~ ${vm
        //         .$moment(vm.EndOn)
        //         .format("YYYY-MM-DD")}`;
        //     return date;
        // }
    },
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imgbtncard {
    width: 100%;
    padding: 10px;
    /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); */
    border: 1px solid rgb(144, 143, 143, 0.4);
    transition: 0.35s;
}
.imgbtncard:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.16), 0 10px 10px rgba(0, 0, 0, 0.22);
    transform: translateY(-2px);
}
.imgbtncard .img {
    width: 100%;
    font-size: 0;
    margin: auto;
    height: 360px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: #fff;
}
.imgbtncard .img img {
    width: 100%;
    max-height: 100%;
}
.imgbtncard .title {
    padding: 15px 0;
    text-align: center;
    line-height: 1.5;
    letter-spacing: 2px;
}
.imgbtncard .date {
    text-align: center;
    margin-bottom: 25px;
}
.imgbtncard .btn_box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
}
.imgbtncard .btn_box .btn {
    width: 48%;
    text-align: center;
}
@media screen and (max-width: 1520px) {
    .imgbtncard .btn_box .btn {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/information/imgbtnCard.vue